import * as types from "./mutationTypes";

export default {
  [types.SET_ERROR](state) {
    state.error = true;
  },
  [types.CLEAR_ERROR](state) {
    state.error = false;
  },
  [types.SET_EMAIL](state, email) {
    state.email = email;
  },
  [types.CLEAR_EMAIL](state) {
    state.email = null;
  },
  [types.SET_PASSWORD](state, password) {
    state.password = password;
  },
  [types.SET_CONFIRM_PASSWORD](state, password) {
    state.confirmPassword = password;
  },
  [types.CLEAR_PASSWORD](state) {
    state.password = null;
  },
  [types.CLEAR_CONFIRM_PASSWORD](state) {
    state.confirmPassword = null;
  },
  [types.SET_CURRENT_PASSWORD](state, password) {
    state.currentPassword = password;
  },
  [types.CLEAR_CURRENT_PASSWORD](state) {
    state.currentPassword = null;
  }
};
